import React from 'react';
import {useSelector} from 'react-redux';

import * as S from './SRPHeader.styles';

import {commonSelectorFn} from '../../../../../shared/pages/common/redux/selectors';

const Header = () => {
  const {destination} = useSelector(commonSelectorFn);

  return (
    <S.WrapperDiv>
      <S.InnerWrapperDiv>
        <S.TextWrapper>
          <div className="sub-text">Hotels of</div>
          <div className="main-text">{destination.n}</div>
        </S.TextWrapper>
      </S.InnerWrapperDiv>
    </S.WrapperDiv>
  );
};

export default Header;
